import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  EditButton,
  DeleteButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  FilterButton,
  SearchInput,
  BooleanInput,
  Filter,
} from 'react-admin';

const ContactGroupFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <BooleanInput source="isActive" />
  </Filter>
);

const ContactGroupListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const ContactGroupList = () => (
  <List
    filters={<ContactGroupFilter />}
    actions={<ContactGroupListActions />}
    sort={{ field: 'sortOrder', order: 'ASC' }}
    perPage={25}
  >
    <Datagrid rowClick="show">
      <TextField source="name" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
